export enum TranslogChain {
  BNB = 'BNB',
  ETH = 'ETH',
  TRX = 'TRX',
}
